export default "__VITE_PUBLIC_ASSET__222a73c5__"